import { ClickAwayListener, SwipeableDrawer } from "@mui/material";

import Puller from "./Puller";

const InfoV2 = ({
  children,
  open,
  handleClose,
  heightPercent = 85,
  showPuller = true,
}) => {
  return (
    <ClickAwayListener onClickAway={() => {}}>
      <SwipeableDrawer
        open={open}
        anchor="bottom"
        onOpen={() => {}}
        onClose={handleClose}
        ModalProps={{
          keepMounted: true,
        }}
        PaperProps={{
          elevation: 0,
          square: false,
          sx: {
            borderTopLeftRadius: "15px",
            borderTopRightRadius: "15px",
            overflow: "visible",
            height: `calc(${heightPercent}%)`,
          },
        }}
        sx={{ zIndex: 1300 }}
      >
        {showPuller ? <Puller /> : null}
        {children}
      </SwipeableDrawer>
    </ClickAwayListener>
  );
};

export default InfoV2;
